import { type DisciplinePhaseManager } from '../../types'
import { MobileDetector } from '@powerplay/core-minigames'
import { player } from '@/app/entities/athlete/player'
import {
  actionButtonState,
  inputsState,
  tutorialState
} from '@/stores'

/**
 * Trieda fazy pre zjazd
 */
export class RunningPhase implements DisciplinePhaseManager {

  /** koeficient na nasobenie rychlosti a casov pri speedLocku */
  public speedLockCoef = 1

  /** callback na zavolanie po skonceni fazy */
  public callbackEnd: () => unknown

  /** Ci je aktivna faza */
  public isActive = false

  /**
   * Konstruktor
   */
  public constructor(callbackEnd: () => unknown) {

    this.callbackEnd = callbackEnd

  }

  /**
   * Pripravenie fazy
   */
  public preparePhase = (): void => {

    // zatial netreba nic

  }

  /**
   * Start fazy
   */
  public startPhase = (): void => {

    console.warn('game phase started')
    this.isActive = true

  }

  /**
   * Zobrazenie mobilnych buttonov
   */
  public showMobileButtons(): void {

    if (!MobileDetector.isMobile()) return

    actionButtonState().showJoystick = true
    inputsState().disabled = false

  }

  /**
   * Aktualizovanie fazy
   */
  public update = (): void => {

    if (player.speedLockActive) return
    if (player.velocityManager.framesUnderIdeal === 0 && player.velocityManager.getSpeedPower() < 210) {

      tutorialState().showInstructionBox = false

    }

  }

  /**
   * Inputy pri behu
   */
  public handleInputs(): void {

    if (!this.isActive) return
    player.velocityManager.handleInputs()

  }

  /**
   * Ukoncene fazy
   * @param type - Typ ukoncenia
   */
  public finishPhase = (): void => {

    this.isActive = false
    console.warn('game phase ended')

    this.callbackEnd()

  }

  /**
   * sets finish phase tween
   */
  public setFinishPhaseTween(): void {

    //

  }

  /**
   * reset fazy
   */
  public reset(): void {

    this.speedLockCoef = 1
    this.isActive = false

  }

}
